import React from 'react';
// import TodayView from 'components/finance/TodayView';
import TodayViewContainer from 'containers/finance/TodayViewContainer';
import { useParams } from 'react-router-dom';

import { Helmet, HelmetProvider } from "react-helmet-async";

import dayjs from 'dayjs';


// class FinancePage extends Component {
//   const {id} = useParams();

//   render() {
//     return (
//       <TodayViewContainer />
      
//     );
//   }
// };

// export default FinancePage;

const FinancePage = () => {
  let {id} = useParams();
  
  if(id===null || id==="" || id===undefined) {
    id = dayjs().format('YYYYMMDD');

  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>강세 테마주 정리</title>
          <meta name="description" content="매일 강세 테마주 흐름을 한눈에 정리해드립니다. 관련 종목, 뉴스 흐름, 테마 배경까지 알기 쉽게 분석한 투자 인사이트를 제공합니다." />
          <meta property='og:title' content='오늘의 강세 테마주 관련주 대장주 정리 사이트'/>
          <meta property='og:description' content='오늘의 강세 테마주 정리'/>
        </Helmet>
      </HelmetProvider>
      <TodayViewContainer key={id} id={id} />
    </>
  );
};

export default FinancePage;